exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mark-as-error[data-v-a21864b6]{border:1.5px solid red}.range-filter[data-v-a21864b6]{display:flex;gap:4px}.range-filter input[data-v-a21864b6]{flex:1;min-width:0;height:42px;border-radius:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-a21864b6&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/filter/RangeComponent.vue
// module id = 927
// module chunks = 2